import React from 'react';
import useLocale from '@/hooks/useLocale';
import type { LocaleWithGatorProtectAutomaticProtectionAvailable } from '../../../gatorProtect.types';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardButton,
  ProtectionCardMonarx,
} from '../ProtectionCardCompound';

export const AUTOMATIC_PROTECTION_AVAILABLE_PROTECTION_CARD_TYPE = 'automaticProtectionAvailable' as const;
export type AutomaticProtectionAvailableProtectionCardType =
  typeof AUTOMATIC_PROTECTION_AVAILABLE_PROTECTION_CARD_TYPE;


export type ProPlanVariantProps = {
  testId?: string;
  hideButtons?: boolean;
  hideActivateTrial?: boolean;
  isAAClient?: boolean;
  onActivateProtectionPro?: () => void;
  onActivateTrial?: () => void;
  enableTrial?: boolean;
};

const ProPlanVariant = ({
  testId,
  hideButtons,
  hideActivateTrial,
  isAAClient,
  onActivateProtectionPro,
  onActivateTrial,
  enableTrial,
}: ProPlanVariantProps) => {
  const { gatorProtect } = useLocale() as LocaleWithGatorProtectAutomaticProtectionAvailable;

  if (!gatorProtect?.summary?.protectionCard?.automaticProtectionAvailable) {
    return null;
  }

  const {
    title,
    description,
    activateProtectionPro,
    activateTrial,
  } = gatorProtect.summary.protectionCard.automaticProtectionAvailable;

  const activateTrialByClientType = isAAClient ? activateTrial?.aa : activateTrial?.regular;

  const showTrialButton = enableTrial && !hideActivateTrial && Boolean(activateTrialByClientType);
  const showActions = !hideButtons && Boolean(activateProtectionPro);

  const actionsTestId = `${testId}__actions`;

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{title}</ProtectionCardTitle>
          <ProtectionCardDescription html={description} />
          {showActions && (
            <ProtectionCardActions actionsTestId={actionsTestId}>
              <ProtectionCardButton
                variant={activateProtectionPro.variant}
                hasMultipleButtons={showTrialButton}
                onClick={onActivateProtectionPro}
                testId={`${testId}__action-${activateProtectionPro.key}`}
              >
                {activateProtectionPro.label}
              </ProtectionCardButton>
              {showTrialButton && activateTrialByClientType ? (
                <ProtectionCardButton
                  variant={activateTrialByClientType.variant}
                  hasMultipleButtons
                  onClick={onActivateTrial}
                  testId={`${testId}__action-${activateTrialByClientType.key}`}
                >
                  {activateTrialByClientType.label}
                </ProtectionCardButton>
              ) : null}
            </ProtectionCardActions>
          )}
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={title} />
    </ProtectionCardRoot>
  );
};


export default ProPlanVariant;
